import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _actions from '../../actions';
import VersionBox from '../../components/common/VersionBox';
import i18n from '../../i18n';
import Trash from '../../components/svg/Trash';
import CaptionTooltip from '../../components/common/CaptionTooltip';
import YesNoDialog from '../../components/common/YesNoDialog';
import DeleteDialog from '../../components/common/DeleteDialog';
import EmptyPages from '../../assets/images/empty-pages.png';
import constants from '../../constants';
import AddEditContentModal from '../modals/AddEditContentModal';
import LargeLoading from '../../components/svg/LargeLoading';
import SortablePageSectionsList from '../../components/pages/SortablePageSectionsList';
import PreviewPages from '../../components/preview/PreviewPages';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';
import LargeModal from '../modals/LargeModal';
import SmallModal from '../modals/SmallModal';

export class PagesModule extends React.Component {
    static buildLinks(page) {
        switch (page.linksFrom.length) {
            case 0:
                return <div data-qa={`pages-table-content-links-${page.id}`} className="pages-table-links warning">Unassigned</div>;
            case 1:
                return <div data-qa={`pages-table-content-links-${page.id}`} className="pages-table-links">{page.linksFrom[0]}</div>;
            case 2:
                return <div data-qa={`pages-table-content-links-${page.id}`} className="pages-table-links">{`${page.linksFrom[0]}, ${page.linksFrom[1]}`}</div>;
            default: {
                const fullList = page.linksFrom.map((link) => { return `${link}\u00A0`; }).slice(0, -1);
                return (
                    <CaptionTooltip tooltipText={fullList} placement="bottom">
                        <div data-qa={`pages-table-content-links-${page.id}`} className="pages-table-links">{`${page.linksFrom[0]}, ${page.linksFrom.length - 1} More`}</div>
                    </CaptionTooltip>
                );
            }
        }
    }

    static buildShowsOn(page) {
        switch (page.linksFrom.length) {
            case 0:
                return <div data-qa="pages-edit-shows-on" className="shows-on warning">Shows On: Unassigned</div>;
            case 1:
                return <div data-qa="pages-edit-shows-on" className="shows-on">{`Shows On: ${page.linksFrom[0]}`}</div>;
            case 2:
                return <div data-qa="pages-edit-shows-on" className="shows-on">{`Shows On: ${page.linksFrom[0]}, ${page.linksFrom[1]}`}</div>;
            default: {
                const fullList = `Shows On: ${page.linksFrom.map((link) => { return `${link}\u00A0`; }).slice(0, -1)}`;
                return (
                    <CaptionTooltip tooltipText={fullList} placement="bottom">
                        <div data-qa="pages-edit-shows-on" className="shows-on">{`${page.linksFrom[0]}, ${page.linksFrom.length - 1} More`}</div>
                    </CaptionTooltip>
                );
            }
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            showDeleteModal: false,
            showAddEditModal: false,
            deletingItem: {},
            addEditItem: {},
            filteredPageList: [],
            loadOnce: false,
            listOrEditor: 0,
            pageToEdit: {},
            formsLoaded: false,
            pagesLoaded: false,
            allForms: [],
            allPages: [],
            sectionsLoading: false,
            sections: [],
            previewSections: [],
            showUpsellModal: false,
            showPreview: true,
        };

        this.handleDeleteIcon = this.handleDeleteIcon.bind(this);
        this.handleAddDivider = this.handleAddDivider.bind(this);
        this.closeDeleteModal = this.closeDeleteModal.bind(this);
        this.deletePage = this.deletePage.bind(this);
        this.showAddPageModal = this.showAddPageModal.bind(this);
        this.showEditPageModal = this.showEditPageModal.bind(this);
        this.setStateFromEvent = this.setStateFromEvent.bind(this);
        this.savePage = this.savePage.bind(this);
        this.isAddEditValid = this.isAddEditValid.bind(this);
        this.drillToPage = this.drillToPage.bind(this);
        this.backToList = this.backToList.bind(this);
        this.handleDeleteContentSection = this.handleDeleteContentSection.bind(this);
        this.handleDisplayOrderChange = this.handleDisplayOrderChange.bind(this);
        this.handleAddContentSection = this.handleAddContentSection.bind(this);
        this.handleSectionChange = this.handleSectionChange.bind(this);
        this.handleAddContent = this.handleAddContent.bind(this);
        this.handleDeleteContent = this.handleDeleteContent.bind(this);
        this.handleUpdateContent = this.handleUpdateContent.bind(this);
        this.handleShowPreview = this.handleShowPreview.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getPagesforProject(this.props.match.params.projectId);
        this.props.actions.getModuleByTypeAndForms(this.props.match.params.projectId, constants.ModuleType.find((mt) => { return mt.Name === 'Discover'; }).Id, true);
        this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.modules.inProgress && prevProps.modules.inProgress) {
            if (this.props.pages.data && this.props.pages.data.length > 0) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    filteredPageList: this.props.pages.data.filter((page) => {
                        return page.id.toUpperCase() !== this.props.modules.select.pageId.toUpperCase();
                    }),
                    loadOnce: true,
                });
            }
        }
        if (!this.props.pages.inProgress && prevProps.pages.inProgress) {
            if (this.props.modules.select && this.props.modules.select.pageId) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    filteredPageList: this.props.pages.data.filter((page) => {
                        return page.id.toUpperCase() !== this.props.modules.select.pageId.toUpperCase();
                    }),
                    loadOnce: true,
                });
            }
            if (this.props.match.params.pageId?.length > 1) {
                const page = this.props.pages.data.find((p) => { return p.id === this.props.match.params.pageId; });
                if (page == null || typeof page === 'undefined') {
                    this.props.history.push(`/projects/${this.props.match.params.projectId}/pages/pages`);
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({ listOrEditor: 0 });
                } else {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({ listOrEditor: 1, pageToEdit: page, sections: page.contentSections, previewSections: page.contentSections });
                }
            }
        }
        if (prevProps.forms.inProgress && !this.props.forms.inProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                formsLoaded: true,
                allForms: this.props.forms.filtered,
            });
        }
        if (prevProps.pages.dropInProgress && !this.props.pages.dropInProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                pagesLoaded: true,
                allPages: this.props.pages.dropdown,
            });
        }
        if (!this.props.pages.inProgress && prevProps.pages.inProgress) {
            const temp = this.props.pages.data.find((m) => { return m.id === this.state.pageToEdit.id; });
            // eslint-disable-next-line react/no-did-update-set-state
            if (typeof (temp) !== 'undefined') this.setState({ sections: temp.contentSections, previewSections: temp.contentSections, sectionsLoading: false });
        }

        if (!this.props.versions.publishProgress && prevProps.versions.publishProgress && !this.props.versions.publishFailed) {
            this.props.actions.getModuleByTypeAndForms(this.props.match.params.projectId, constants.ModuleType.find((mt) => { return mt.Name === 'Discover'; }).Id, true);
        }
    }

    handleDeleteIcon(item) {
        this.setState({ showDeleteModal: true, deletingItem: item });
    }

    setStateFromEvent(e, stateKey) {
        // checkboxes
        if (stateKey === 'hasMenuItem') {
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.pageToEdit[stateKey] = e.target.checked; return { pageToEdit: { ...prevState.pageToEdit } }; });
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.addEditItem[stateKey] = e.target.checked; return { addEditItem: { ...prevState.addEditItem } }; });
        } else {
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.pageToEdit[stateKey] = e.target.value; return { pageToEdit: { ...prevState.pageToEdit } }; });
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.addEditItem[stateKey] = e.target.value; return { addEditItem: { ...prevState.addEditItem } }; });
        }
    }

    formatFormsForSelect = (items) => {
        const formattedItems = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const item of items) {
            formattedItems.push({
                label: item.name,
                value: item.id,
            });
        }
        return formattedItems;
    }

    formatPagesForSelect = (items) => {
        const formattedItems = [];
        formattedItems.push({
            label: i18n.t('pages.tapType5'),
            value: '5',
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const item of items) {
            if (item.id !== this.state.pageToEdit.id) {
                formattedItems.push({
                    label: item.name,
                    value: item.id,
                });
            }
        }
        return formattedItems;
    }

    // eslint-disable-next-line react/sort-comp
    drillToPage(page) {
        this.props.history.push(`/projects/${this.props.match.params.projectId}/pages/pages/${page.id}`);
        this.setState({ listOrEditor: 1, pageToEdit: page, sections: page.contentSections, previewSections: page.contentSections });
    }

    backToList() {
        this.setState({ listOrEditor: 0, pageToEdit: {}, sections: [], previewSections: [] });
        this.props.history.push(`/projects/${this.props.match.params.projectId}/pages/pages`);
    }

    closeDeleteModal() {
        this.setState({ showDeleteModal: false });
    }

    showAddPageModal() {
        if (this.props.flags.results.customContentPageCount + 1 > this.props.pages.data.length) {
            this.setState({
                showAddEditModal: true,
                isAdd: true,
                addEditItem: { projectVersionId: this.props.versions.select.id, name: '', hasMenuItem: true },
            });
        } else {
            this.setState({
                showUpsellModal: true,
            });
        }
    }

    showUpsellModal = () => {
        this.setState({ showUpsellModal: true });
    }

    showEditPageModal(page) {
        this.setState({
            showAddEditModal: true, isAdd: false, addEditItem: page,
        });
    }

    savePage(newName, newHasMenuItem, newIcon) {
        const updatedAddEditItem = { ...this.state.addEditItem, name: newName, hasMenuItem: newHasMenuItem };
        if (this.state.isAdd) {
            this.props.actions.addPage(updatedAddEditItem, this.props.match.params.projectId, newIcon);
        } else {
            this.props.actions.updatePage(updatedAddEditItem, this.props.match.params.projectId);
            if (newIcon !== null) {
                this.props.actions.updateMenuItemParameter(this.props.match.params.projectId, this.state.addEditItem.id, 2, 'icon', newIcon);
            }
        }
        this.setState({ showAddEditModal: false, addEditItem: {} });
    }

    deletePage() {
        this.props.actions.deletePage(this.state.deletingItem.id, this.state.deletingItem.name, this.props.match.params.projectId);
        this.closeDeleteModal();
        this.backToList();
    }

    isAddEditValid() {
        return {
            isValid: this.state.addEditItem.name && this.state.addEditItem.name.length > 0,
            message: i18n.t('pages.add.validation.name-required'),
        };
    }

    // eslint-disable-next-line react/sort-comp
    handleDeleteContentSection(e) {
        this.setState({ sectionsLoading: true, previewSections: this.props.sections });
        this.props.actions.deleteContentSection(e, this.props.match.params.projectId);
    }

    handleAddContentSection() {
        this.setState({ sectionsLoading: true, previewSections: this.props.sections });
        this.props.actions.addContentSectionToPage(this.state.pageToEdit.id, this.props.match.params.projectId);
    }

    handleAddDivider(precedingId, sectionId) {
        this.setState({ sectionsLoading: true, previewSections: this.props.sections });
        const divider = { contentSectionId: sectionId, contentType: 102, precedingContentId: precedingId };
        this.props.actions.addContentToSection(divider, this.props.match.params.projectId);
    }

    handleDisplayOrderChange(e) {
        this.props.actions.reorderPageSections(this.state.pageToEdit.id, this.props.match.params.projectId, e);
        this.setState({ previewSections: e });
    }

    handleSectionChange(section) {
        this.setState({ sectionsLoading: true, previewSections: this.props.sections });
        this.props.actions.updateContentSection(section, this.props.match.params.projectId);
    }

    handleAddContent(content) {
        this.setState({ sectionsLoading: true, previewSections: this.props.sections });
        this.props.actions.addContentToSection(content, this.props.match.params.projectId);
    }

    handleDeleteContent(id) {
        this.setState({ sectionsLoading: true, previewSections: this.props.sections });
        this.props.actions.deleteContent(id, this.props.match.params.projectId);
    }

    handleUpdateContent(content) {
        this.setState({ sectionsLoading: true, previewSections: this.props.sections });
        this.props.actions.updateContent(content, this.props.match.params.projectId);
    }

    handleShowPreview(value) {
        this.setState({ showPreview: value });
    }

    render() {
        let activeCheckin = this.props.modules.data
            .filter(module => module.moduleType === constants.ModuleType
                .find(m => m.Name === 'Check-In').Id);
        activeCheckin = activeCheckin.filter(module => module.enabled === true);
        const formItems = this.state.formsLoaded ? this.formatFormsForSelect(this.state.allForms) : [];
        const pagesItems = this.state.pagesLoaded ? this.formatPagesForSelect(this.state.allPages) : [];
        const deleteModal = (
            <YesNoDialog
                Message={<DeleteDialog open={i18n.t('projects.delete1')} message={`${i18n.t('pages.deleteWarning1')} '${this.state.deletingItem.name}' ${i18n.t('pages.deleteWarning2')}`} warning={i18n.t('pages.deleteWarning3')} />}
                ExecuteAction={this.deletePage}
                CloseDialog={this.closeDeleteModal}
                Visible={this.state.showDeleteModal}
                YesText={i18n.t('delete')}
                NoText={i18n.t('cancel')}
                title="Delete Page?"
            />
        );
        const addEditPageModal = (
            <AddEditContentModal
                addEditItem={this.state.addEditItem}
                savePage={this.savePage}
                isAdd={this.state.isAdd}
                visible={this.state.showAddEditModal}
                close={() => { this.setState({ showAddEditModal: false, addEditItem: {} }); }}
                userSelectedIcons={this.props.flags?.results?.userSelectedIcons}
                icon={this.state.isAdd ? constants.IconList.find((f) => {
                    return f.value === 'file';
                }) : constants.IconList.find((f) => {
                    return f.value === this.props.menuItems?.data?.find((m) => {
                        return m.subType === this.state.addEditItem?.id;
                    })?.icon;
                })}
            />
        );
        const loadingPage = (
            <div id="loading-page">
                <h1 data-qa="pages-page-header" id="pages-page-header">{i18n.t('menu.pages')}</h1>
                <div id="loading-container_loader">
                    <LargeLoading />
                </div>
            </div>
        );
        const upsell = (<SmallModal alertView="pages-modal" visible={this.state.showUpsellModal} close={() => { this.setState({ showUpsellModal: false }); }} >
            <div className='modal-content text-center' >Page limit exceeded</div>
        </SmallModal>);
        const emptyPage = (
            <div className="form-wrapper">
                <h1 data-qa="pages-page-header" id="pages-page-header">{i18n.t('menu.pages')}</h1>
                <p data-qa="pages-page-subhead" id="pages-page-subhead" className="lead">{i18n.t('pages.empty-subtitle')}</p>
                <div className="empty-pages">
                    <img height="296px" width="306px" src={EmptyPages} />
                    <div>
                        <button type="button" className="btn-design-system primary" onClick={this.showAddPageModal}>{i18n.t('pages.add-page')}</button>
                    </div>
                </div>
            </div>
        );
        const table = (
            <div className="form-wrapper">
                <h1 data-qa="pages-page-header" id="pages-page-header">{i18n.t('menu.pages')}</h1>
                <p data-qa="pages-page-subhead" id="pages-page-subhead" className="lead">{i18n.t('pages.subtitle')}</p>
                <div className="table-wrap">
                    <div className="table-header-row" style={{ msGridColumns: '( 1fr )[5]' }}>
                        <div className="pages-table-name"><span>{i18n.t('pages.name')}</span></div>
                        <div className="pages-table-links"><span>{i18n.t('pages.links')}</span></div>
                        <div className="pages-table-actions">
                            <button type="button" className="btn-design-system primary" onClick={this.showAddPageModal}>{i18n.t('pages.add-page')}</button>
                        </div>
                    </div>
                    <div className="table-content">
                        {this.state.filteredPageList.length > 0 && this.state.filteredPageList.map((item, index) => {
                            return (
                                <div data-qa={`pages-table-content-row-${item.id}`} className={index % 2 === 0 ? 'table-content-row' : 'table-content-row alternating'} key={item.id} style={{ msGridColumns: '( 1fr )[5]' }}>
                                    <div data-qa={`pages-table-content-name-${item.id}`} className="pages-table-name emphasized">
                                        {this.props.flags?.results?.userSelectedIcons && item.hasMenuItem && <UserSelectedIconSelect id={item.id} type={2} autoUpdate />}
                                        {!this.props.flags?.results?.userSelectedIcons && item.hasMenuItem
                                            && (
                                                <span className="btn-design-system medium icon user-icon">
                                                    <FontAwesomeIcon
                                                        icon={['fal', this.props.menuItems?.data?.find((m) => { return m.subType === item.id; })?.icon]}
                                                        color="#616B7D"
                                                    />
                                                </span>
                                            )}
                                        <div data-qa={item.id} className={`link ${item.hasMenuItem ? '' : 'no-icon'}`} onClick={() => { this.drillToPage(item); }} onKeyPress={() => { this.drillToPage(item); }} aria-label="Edit" role="link" tabIndex={0}>{item.name}</div>
                                    </div>
                                    {PagesModule.buildLinks(item)}
                                    <div data-qa={`pages-table-content-actions-${item.id}`} className="pages-table-actions">
                                        <CaptionTooltip tooltipText="Edit">
                                            <button
                                                aria-label="Edit"
                                                data-qa={`pages-table-content-edit-${item.id}`}
                                                className="edit action"
                                                type="button"
                                                onClick={() => { this.drillToPage(item); }}
                                            >
                                                <FontAwesomeIcon icon={['fas', 'pencil']} color="#616B7D" onClick={this.focusTextInput} />
                                            </button>
                                        </CaptionTooltip>
                                        <CaptionTooltip tooltipText="Delete">
                                            {/* eslint-disable-next-line */}
                                            <button
                                                aria-label="Delete"
                                                data-qa={`pages-table-content-delete-${item.id}`}
                                                className="delete action"
                                                type="button"
                                                onClick={() => {
                                                    this.handleDeleteIcon(item);
                                                }}
                                            >
                                                <Trash />
                                            </button>
                                        </CaptionTooltip>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
        const editPage = (
            <>
                <div className="top-bar">
                    <div className="breadcrumb-holder" onClick={this.backToList} onKeyPress={this.backToList} aria-label="Back to List" role="link" tabIndex={0}>
                        <div className="breadcrumb-icon"><FontAwesomeIcon icon={['fas', 'chevron-left']} color={constants.StyleColors.grey35} /></div>
                        <div className="breadcrumb-text">{i18n.t('menu.pages')}</div>
                    </div>
                    <div className="buttonHolder">
                        <CaptionTooltip placement="bottom" tooltipText={i18n.t('pages.delete-page')}>
                            <button
                                className="btn-design-system secondary icon large error"
                                id="btn-delete-page"
                                type="button"
                                onClick={() => {
                                    this.handleDeleteIcon(this.state.pageToEdit);
                                }}
                            >
                                <FontAwesomeIcon icon={['fas', 'trash']} color={constants.StyleColors.error2} />
                            </button>
                        </CaptionTooltip>
                        <CaptionTooltip placement="bottom" tooltipText={i18n.t('pages.edit-page')}>
                            <button
                                className="btn-design-system secondary icon large"
                                id="btn-edit-page"
                                type="button"
                                onClick={() => {
                                    this.showEditPageModal(this.state.pageToEdit);
                                }}
                            >
                                <FontAwesomeIcon icon={['fas', 'cog']} color={constants.StyleColors.grey35} />
                            </button>
                        </CaptionTooltip>
                    </div>
                </div>
                <div className="form-wrapper edit">
                    {this.state.pageToEdit?.linksFrom && PagesModule.buildShowsOn(this.state.pageToEdit)}
                    <h1>
                        {' '}
                        {this.state.pageToEdit?.linksFrom?.length > 0
                            ? <FontAwesomeIcon icon={['fas', this.props.menuItems?.data?.find((m) => { return m.subType === this.state.pageToEdit.id; })?.icon]} color="#616B7D" />
                            : ''}
                        {this.state.pageToEdit.name}
                    </h1>
                    <p className="lead">{i18n.t('pages.editor-subtitle')}</p>
                    <SortablePageSectionsList
                        flags={this.props.flags}
                        sections={this.state.sections}
                        onItemsDisplayOrderChange={this.handleDisplayOrderChange}
                        onSingleItemChange={this.handleSectionChange}
                        deleteContentSection={this.handleDeleteContentSection}
                        addContentSection={this.handleAddContentSection}
                        addContent={this.handleAddContent}
                        addDivider={this.handleAddDivider}
                        updateContent={this.handleUpdateContent}
                        deleteContentBlock={this.handleDeleteContent}
                        changing={this.state.sectionsLoading}
                        formsItems={formItems}
                        formsObjects={this.props.forms.filtered}
                        pagesItems={pagesItems}
                        upsell={this.showUpsellModal}
                        handleShowPreview={this.handleShowPreview}
                    />
                </div>
            </>
        );
        const previewPages = (
            <>
                <PreviewPages
                    accentColor={this.props.versions.select.accentColor}
                    actionColor={this.props.versions.select.actionColor}
                    menuStyle={this.props.versions.select.menuStyle}
                    pageToEdit={this.state.pageToEdit}
                    primaryText={this.props.versions.select.primaryText}
                    secondaryText={this.props.versions.select.secondaryText}
                    sections={this.state.previewSections?.length > 0 ? this.state.previewSections : this.state.sections}
                    menuItems={this.props.menuItems.data}
                    checkin={
                        this.props.flags.results?.chMSIntegration
                        && this.props.flags.results?.chMSCheckIn
                        && activeCheckin.length > 0
                    }
                />
            </>
        );

        return (
            <VersionBox
                name={this.props.versions.select.name}
                versionNumber={this.props.versions.select.version}
                saving={this.props.content.inProgress}
                justSaved={this.props.modules.justSaved}
                menuSection="Pages"
                menuItem="PagesModule"
                previewCssClass="modules_pages"
                previewChild={previewPages}
                showPreview={this.state.showPreview}
                x
            >
                <div id="pages-module" className="content-inside">
                    {this.state.showDeleteModal && deleteModal}
                    {this.state.showAddEditModal && addEditPageModal}
                    {this.state.loadOnce === false && loadingPage}
                    {!(this.props.match.params.pageId?.length > 1) && this.state.loadOnce !== false && this.state.listOrEditor === 0 && (this.props.pages.data && this.props.pages.data.length === 1 ? emptyPage : table)}
                    {this.state.loadOnce !== false && this.state.listOrEditor === 1 && editPage}
                    {this.state.showUpsellModal && upsell}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PagesModule);
